module.exports = "<ngx-spinner bdOpacity=0.9 bdColor=\"#333\" size=\"medium\" color=\"#fff\" type=\"ball-spin-clockwise\"></ngx-spinner>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared-components/busy-indicator/busy-indicator.component.html
// module id = ./src/app/shared-components/busy-indicator/busy-indicator.component.html
// module chunks = main